module.exports = __webpack_public_path__ + "img/tengxunsp.4f64681d.jpg";